module.exports = __webpack_public_path__ + "static/media/referral-image.42dcb9a4.webp";